// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3JamT","content":"LoadingAlert_content__10E4a"};